import { atom } from 'jotai'

export const sopStepSelectionModeAtom = atom(false)
export const selectedSopStepIdsAtom = atom<Set<string>>(new Set())
